var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditSpecIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 17.5938H0.875C0.460156 17.5938 0.125 17.9289 0.125 18.3438V19.1875C0.125 19.2906 0.209375 19.375 0.3125 19.375H18.6875C18.7906 19.375 18.875 19.2906 18.875 19.1875V18.3438C18.875 17.9289 18.5398 17.5938 18.125 17.5938ZM3.53984 15.625C3.58672 15.625 3.63359 15.6203 3.68047 15.6133L7.62266 14.9219C7.66953 14.9125 7.71406 14.8914 7.74688 14.8563L17.682 4.92109C17.7038 4.89941 17.721 4.87366 17.7328 4.8453C17.7445 4.81695 17.7506 4.78656 17.7506 4.75586C17.7506 4.72516 17.7445 4.69477 17.7328 4.66642C17.721 4.63806 17.7038 4.61231 17.682 4.59063L13.7867 0.692969C13.7422 0.648438 13.6836 0.625 13.6203 0.625C13.557 0.625 13.4984 0.648438 13.4539 0.692969L3.51875 10.6281C3.48359 10.6633 3.4625 10.7055 3.45312 10.7523L2.76172 14.6945C2.73892 14.8201 2.74707 14.9493 2.78545 15.071C2.82384 15.1927 2.89132 15.3032 2.98203 15.393C3.13672 15.543 3.33125 15.625 3.53984 15.625ZM5.11953 11.5375L13.6203 3.03906L15.3383 4.75703L6.8375 13.2555L4.75391 13.6234L5.11953 11.5375Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditSpecIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditSpecIcon.3536f2e2.svg";
export { ForwardRef as ReactComponent };